import { DataBean } from "../DataBean";

export class DisabilityCodes extends DataBean {

  public async getDisabilityCodesCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getDisabilityCodesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteDisabilityCodes(idisabilitycodes: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deleteDisabilityCodes_Number",
      [idisabilitycodes]
    );
  }

  public async updateDisabilityCodes(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.DisabilityCodes_updateDisabilityCodes_com.orange.people.talent.bean.DisabilityCodes",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.DisabilityCodes",
        },
      ]
    );
  }
}
